export function initialProgression() {
    return {
        upgrades: {},
        milestones: {},
        achievements: {},
        activeChallenges: new Set(),
        challengeCompletions: {},
        rewardLedger: new Set(),
        automation: {},
        won: false,
        events: [],
    };
}
export function cloneProgression(source) {
    return {
        upgrades: { ...source.upgrades },
        milestones: { ...source.milestones },
        achievements: { ...source.achievements },
        activeChallenges: new Set(source.activeChallenges),
        challengeCompletions: { ...source.challengeCompletions },
        rewardLedger: new Set(source.rewardLedger),
        automation: Object.fromEntries(Object.entries(source.automation).map(([id, state]) => [id, { ...state }])),
        won: source.won,
        events: [...source.events],
    };
}
export function freezeProgression(source) {
    return Object.freeze({
        upgrades: Object.freeze(source.upgrades),
        milestones: Object.freeze(source.milestones),
        achievements: Object.freeze(source.achievements),
        activeChallenges: Object.freeze([...source.activeChallenges].sort()),
        challengeCompletions: Object.freeze(source.challengeCompletions),
        rewardLedger: Object.freeze([...source.rewardLedger].sort()),
        automation: Object.freeze(Object.fromEntries(Object.entries(source.automation).map(([id, state]) => [id, Object.freeze(state)]))),
        won: source.won,
        events: Object.freeze(source.events.map((event) => Object.freeze({ ...event }))),
    });
}
//# sourceMappingURL=progression-state.js.map